import axios from "axios";

/**
 * Descarga un archivo de un endpoint autenticado del API y lo guarda con `filename`.
 * @param {string} path Ruta relativa al API (ej: "/mobiliario/plantilla")
 * @param {string} filename Nombre sugerido del archivo
 */
export const descargarArchivo = async (path, filename) => {
  const token = localStorage.getItem("token");
  const res = await axios.get(`${process.env.REACT_APP_API_URL}${path}`, {
    headers: { Authorization: `Bearer ${token}` },
    responseType: "blob",
  });

  const url = window.URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
};
